const ErrMsg: { [key: string]: string } = {
    "name/empty": "이름을 입력해주세요",
    "company/empty": "회사명을 입력해주세요",
    "email/empty": "이메일을 입력해주세요",
    "email/invalid": "이메일을 정확히 입력해주세요",
    "contact/empty": "회사명을 입력해주세요",
    "content/empty": "회사명을 입력해주세요",
};

export default ErrMsg;
